<app-dialog [config]="data.config" (actionButtonClicked)="onAction($event)">
    <ng-container dialog-title>
        <i class="fa fa-ban mr-2 text-danger"></i>
        Deactivate Feeds/Bundles
    </ng-container>

    <ng-container dialog-process-in-progress>
        <div class="py-2 deactivate-subscription-dialog">

            <div class="mb-3">
                <div><span class="text-muted">User:</span> {{ userFullName }} ({{ model.userId }})</div>
                <div>
                    <span class="text-muted">Account:</span> {{ model.accountReference }}
                    <span *ngIf="model.tradingPlatformName"> &mdash; {{ model.tradingPlatformName }}</span>
                </div>
            </div>

            <ng-container *ngIf="eligibleSubscriptions.length > 0; else noEligible">

                <div class="mb-2 d-flex justify-content-between align-items-center">
                    <label class="mb-0 cursor-pointer">
                        <input type="checkbox" [checked]="isAllSelected" (change)="toggleSelectAll()"/>
                        <span class="ml-1">{{ isAllSelected ? 'Clear all' : 'Select all' }}</span>
                    </label>
                    <span class="text-muted">{{ selectedCount }} selected</span>
                </div>

                <div *ngIf="isAllSelected && previewCounts" class="alert alert-info py-2 mb-2">
                    All active &amp; future subscriptions for this account:
                    total {{ previewCounts.eligibleCount }}
                    (active {{ previewCounts.activeCount }}, future {{ previewCounts.futureCount }}).
                    <div class="small">This includes eligible subscriptions that may not be visible due to filtering or list limits.</div>
                </div>

                <ul class="list-unstyled subscription-list mb-3">
                    <li *ngFor="let subscription of eligibleSubscriptions" class="d-flex align-items-center py-1">
                        <input type="checkbox"
                               [checked]="isSelected(subscription.id)"
                               (change)="toggleSubscription(subscription.id)"/>
                        <span class="ml-2">{{ subscription.bundle.name }}</span>
                        <span class="badge ml-2"
                              [ngClass]="isSubscriptionActive(subscription) ? 'badge-success' : 'badge-secondary'">
                            {{ isSubscriptionActive(subscription) ? 'Active' : 'Future' }}
                        </span>
                    </li>
                </ul>

                <form [formGroup]="formGroup" class="card-form" autocomplete="off">
                    <app-datepicker
                        [formControlName]="effectiveDateControl.name"
                        [control]="effectiveDateControl">
                    </app-datepicker>
                </form>
            </ng-container>

            <ng-template #noEligible>
                <div class="alert alert-secondary mb-0">
                    There are no active or future subscriptions eligible for deactivation.
                </div>
            </ng-template>
        </div>
    </ng-container>
</app-dialog>
